export enum VehicletypeEnum{
    IN_HOUSE_VEHICLE='IN HOUSE',
    VENDOR_VEHICLE='VENDOR'
}